import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../../common/modaltypes'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { Item } from '../../../../common/snippets'
import { useTranslation } from '../../../../../i18n/I18nProvider'
const ConfirmModal = ({ updateModal, saveLuggageCityData }) => {
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        focusElemnt('yesBtn')
    }, [])
    return (
        <Modal
            headTxt={tr('luggageCities', 'Luggage Cities')}
            width={'35%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <Box>
                <Box sx={{ padding: '24px 15px' }}>
                    <Typography variant='h6' sx={{ fontWeight: '500', color: "#444", fontSize: '16px' }}>
                        {tr('doYouWantSaveLuggagePolicy', 'Do you want to save the Updated Luggage Cities Policy ?')}
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'end', padding: '4px 15px' }} className='itemButtons'>
                    <Item className="disabled-wrapper">
                        <Button variant="outlined" id='noBtn' style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }} className="receiveitembtn"
                            onClick={() => {
                                updateModal(false, mdt.saveLuggageCityData)
                                focusElemnt('Select_Source_State')
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, 'yesBtn', 'yesBtn', () => { })
                            }}
                        >
                            {tr('noUpper', 'NO')}
                        </Button>
                    </Item>
                    <Item className="disabled-wrapper">
                        <Button variant="outlined" id='yesBtn' style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }} className="receiveitembtn"
                            onClick={() => {
                                saveLuggageCityData()
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, 'noBtn', 'noBtn', () => { })
                            }}
                        >
                            {tr('yesUpper', 'YES')}
                        </Button>
                    </Item>
                </Box>
            </Box>

        </Modal>
    )
}

export default ConfirmModal
